// Bepaalt engagement uit signalen.
// Volgorde:
//   - cold start (te jong) → gray
//   - geen recente login → red
//   - rolling baseline check (eventsLast8w t.o.v. eventsLast8wPrevPeriod)
//   - single-user dependency caps op yellow
//   - fallback op login-recency wanneer event-data ontbreekt

import {
    COLD_START_BUSINESS_DAYS,
    ENGAGEMENT_RED_DROP,
    ENGAGEMENT_YELLOW_DROP,
    NO_RECENT_ACTIVITY_DAYS,
    STALE_LOGIN_DAYS,
} from './thresholds';

const computeEngagementScore = (entity, signals) => {
    if (signals.daysSinceCreated < COLD_START_BUSINESS_DAYS) return 'gray';

    if (signals.lastLoginBusinessDaysAgo === null || signals.lastLoginBusinessDaysAgo > NO_RECENT_ACTIVITY_DAYS) {
        return 'red';
    }

    const baseline = signals.eventsLast8wPrevPeriod;
    const current = signals.eventsLast8w;

    if (baseline > 0) {
        const drop = (baseline - current) / baseline;
        if (drop > ENGAGEMENT_RED_DROP) return 'red';
        if (drop > ENGAGEMENT_YELLOW_DROP) return 'yellow';
    } else if (current === 0) {
        // Geen event-data — fallback op login-recency
        if (signals.lastLoginBusinessDaysAgo > STALE_LOGIN_DAYS) return 'yellow';
    }

    if (signals.activeUserCountLast30wd <= 1) return 'yellow';

    return 'green';
};

export default computeEngagementScore;
